import { render, staticRenderFns } from "./company-type.vue?vue&type=template&id=11112410&scoped=true&lang=pug"
import script from "./company-type.vue?vue&type=script&lang=js"
export * from "./company-type.vue?vue&type=script&lang=js"
import style0 from "./company-type.vue?vue&type=style&index=0&id=11112410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11112410",
  null
  
)

export default component.exports